module.exports = __webpack_public_path__ + "img/avatar.49a6bdb9.png";